module.exports = __webpack_public_path__ + "static/media/Volunteers.3cf05ea5.jpg";